import JQuery from "jquery";
import intlTelInput, { Iti } from "intl-tel-input";

export default class TelephoneInput {
  private readonly inputElement: JQuery<HTMLElement>;
  private readonly intlElement: Iti;

  constructor(inputElement: JQuery<HTMLInputElement>) {
    this.inputElement = inputElement;
    this.intlElement = intlTelInput(inputElement[0], {
      loadUtils: () => import("intl-tel-input/utils"),
      separateDialCode: true,
      initialCountry: "auto",
      geoIpLookup: (callback) => {
        fetch("https://ipapi.co/json")
          .then((res) => res.json() as Promise<{ country_code: string }>)
          .then((data) => callback(data.country_code))
          .catch(() => callback("ca"));
      },
    });
    // on keyup events
    this.inputElement.on("keyup keypress blur change", () => this.onChange());

    // reset telephone field if country is changed
    $(".iti__country-list li").on("click", () => this.onClick());
  }

  private onChange(): void {
    // inject country code into hidden field
    $(".field-tel-country-code").val($(".iti__selected-dial-code").html());

    // TODO: Remove actions hide/show actions on labels once new form design has been applied to all existing forms

    // validate localized tel number
    if (!this.intlElement.isValidNumber()) {
      this.inputElement
        .addClass("isInvalid")
        .removeClass("isValid")
        .closest(".form-field-legacy")
        .find("label")
        .addClass("hide");
      this.inputElement.closest(".form-field").find("p").removeClass("hide");
    } else {
      this.inputElement
        .removeClass("isInvalid")
        .addClass("isValid")
        .closest(".form-field-legacy")
        .find("label")
        .removeClass("hide");
      this.inputElement.closest(".form-field").find("p").addClass("hide");
    }
  }

  private onClick(): void {
    this.inputElement.val("");
    this.inputElement
      .removeClass("isInvalid")
      .addClass("isValid")
      .closest(".form-field-legacy")
      .find("label")
      .removeClass("hide");
    this.inputElement.closest(".form-field").find("p").addClass("hide");
  }
}
